import React from 'react'
import ReactPaginate from 'react-paginate'
import { useMedia, useMemo } from 'sb-hooks'

import s from './Pagination.scss'


type PaginationProps = {
  pagesCount: number
  forcePage: number
  onClick: ({ selected: number }) => void
}


const Pagination: React.FunctionComponent<PaginationProps> = ({ pagesCount, forcePage, onClick }) => {
  const { isMobile } = useMedia()

  const breakLabelNode = useMemo(() => (
    <span className={s.breakLabel}>...</span>
  ), [])

  return (
    <ReactPaginate
      forcePage={forcePage}
      activeClassName={s.active}
      containerClassName={s.pagination}
      previousClassName={s.hiddenArrow}
      nextClassName={s.hiddenArrow}
      pageCount={pagesCount}
      marginPagesDisplayed={isMobile ? 1 : 2}
      pageRangeDisplayed={isMobile ? 2 : 5}
      breakLabel={breakLabelNode}
      onPageChange={onClick}
    />
  )
}


export default Pagination
